// extracted by css-extract-rspack-plugin
export default {"removedParentIssuesList":"ParentIssueRemovedEvent-module__removedParentIssuesList___f54d","removedParentIssueItem":"ParentIssueRemovedEvent-module__removedParentIssueItem___KAEv"};